import { createSlice } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
import config from '../config';
import Utils from '../helpers/utils';

const currentLanguage = Cookies.get(config.langCookie);
const initialState = {
  attachmentTypes: [],
  quote: {
    makes: [],
    models: [],
    versions: [],
    versionsLoad: false,
  },
  configuration: { language: currentLanguage },
};
/* eslint-disable no-param-reassign */
export const lookupsSlice = createSlice({
  name: 'lookups',
  initialState,
  reducers: {
    saveAttachmentTypes: (state, action) => {
      const data = [];
      /*
        Prepare MimeTypes data for DropZone
       */
      for (let i = 0; i < action.payload.length; i += 1) {
        const validMimeTypes = action.payload[i].valid_mimetypes.split(';');
        const correctMimeTypes = {};
        for (let y = 0; y < validMimeTypes.length; y += 1) {
          correctMimeTypes[validMimeTypes[y]] = [];
        }
        data.push({
          ...action.payload[i],
          valid_mimetypes: correctMimeTypes,
        });
      }
      state.attachmentTypes = data;
    },
    saveQuoteMakes: (state, action) => {
      const { payload: makes } = action;
      const data = makes.sort((makeA, makeB) => ((makeA.name > makeB.name) ? 1 : -1));
      const values = [];
      for (let i = 0; i < data.length; i += 1) {
        values.push({
          ...data[i],
          value: data[i].id,
          text: data[i].name,
        });
      }
      state.quote.makes = values;
    },
    saveQuoteModels: (state, action) => {
      const { payload: models } = action;
      state.quote.models = Utils.sortModels(models);
    },
    saveQuoteVersions: (state, action) => {
      state.quote.versions = action.payload;
    },
    saveQuoteVersionsLoad: (state, action) => {
      state.quote.versionsLoad = action.payload;
    },
    resetQuoteLookup: (state, action) => {
      const { id } = action.payload;
      state.quote[id] = [];
    },
    loadConfiguration: (state, action) => {
      const { configuration } = action.payload;
      // Hide financial flag if price of vehicle is lower than the financial minimum price
      if (configuration.vehicle && configuration.financial) {
        const { price } = configuration.vehicle;
        const { financial } = configuration.financial;
        if (!Number.isNaN(price) && financial === 'true') {
          const { min_price: minPrice } = configuration.financial.conditions;
          configuration.financial = { ...configuration.financial, financial: configuration.vehicle.price < minPrice ? 'false' : 'true' };
        }
      }
      state.configuration = { ...state.configuration, ...configuration };
    },
    loadExternalServices: (state, action) => {
      const { this_vehicle: thisVehicle, all_vehicles: allVehicles } = action.payload;
      state.configuration.services = {
        this_vehicle: thisVehicle,
        all_vehicles: allVehicles ?? state.configuration.services.all_vehicles,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  saveAttachmentTypes,
  saveQuoteMakes,
  saveQuoteModels,
  saveQuoteVersions,
  saveQuoteVersionsLoad,
  resetQuoteLookup,
  loadConfiguration,
  loadExternalServices,
} = lookupsSlice.actions;
export const lookupsState = (state) => state.lookups;
export default lookupsSlice.reducer;
